/**
 * Well-known capability tokens for RoundSnapshot.possibleClientActions.
 *
 * The server populates possibleClientActions with these (or custom) strings.
 * The shell reads only `gamble` (`GambleOfferFlow.shouldOffer`); `collect`, `feature_gamble` and
 * `start_feature` are named for a title and read by nothing (plan §1.3).
 */
export const PossibleClientActionNames = {
  gamble: "gamble",
  collect: "collect",
  featureGamble: "feature_gamble",
  startFeature: "start_feature",
} as const;
